<template>
  <div class="bs-wrappe img-box">
    <img :src="imgUrl" class="img"/>
  </div>
</template>

<script>
export default {
  name: 'UtilsImg',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {
      isShow: false,
      imgUrl: ''
    };
  },

  computed: {

  },

  watch: {},

  created() {
    document.title = this.$route.query.imgTitle || '万商服';
    this.imgUrl = decodeURIComponent(this.$route.query.imgUrl);
    // this.isShow = this.imgUrl.includes('wanda.cn') || this.imgUrl.includes('beyonds.com');
  },

  mounted() {},

  destroyed() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.img-box {
  overflow-y: auto;
}
.img {
  width: 100%;
}
</style>
